import React, { useEffect, useState } from 'react';
import whatsapp_placeholder from '../assets/images/whatsapp_placeholder.png';
import useSnackbar from "../components/Snackbar/UseSnackbar";
import axios from 'axios';
import { API_DOMAIN } from '../components/constants';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import Avatar from '@mui/material/Avatar';
import { Stack } from '@mui/material';
import { Divider, Input } from 'antd';

function WhatsappMessages() {


    const { SuccessSnackbar, ErrorSnackbar, InfoSnackbar, WarningSnackbar, ToastContainer } = useSnackbar();


    const [chatlist, setChatlist] = useState([]);


    function stringToColor(string) {
        let hash = 0;
        let i;

        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */

        return color;
    }

    function stringAvatar(name) {
        if (!name) {
            return "";
        }
        if (name.split(' ').length === 2) {
            // If name has two parts (first name and last name)
            return {
                sx: {
                    bgcolor: stringToColor(name),
                },
                children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
            };
        } else {
            // If name has only one part
            return {
                sx: {
                    bgcolor: stringToColor(name),
                },
                children: `${name.split(' ')[0][0].toUpperCase()}`, // Capitalize first letter
            };
        }
    }


    const getAllChats = () => {
        axios.get(API_DOMAIN + "/whatsapp/get_all_chats", {
            headers: {
                accessToken: localStorage.getItem("accessToken"),
            }
        }).then((res) => {
            if (res.data.success) {
                setChatlist(res.data.data);
                SuccessSnackbar("Chatlist loaded successfully");
            }
            else {

            }
        });
    }

    useEffect(() => {
        // getAllChats();
    }, []);

    return (
        <>

            <div className='border rounded drop-shadow-2 p-2 mt-2' style={{ backgroundColor: "#ebebeb" }}>
                <div className='flex'>
                    <div className='mr-2 border rounded' style={{ backgroundColor: "#cacbcc" }}>

                        {/* This div contains the chats list on the left pane */}
                        <div className='flex justify-center'>

                            <div className='flex align-middle justify-center border rounded mt-2 mb-0' style={{ backgroundColor: "white", width: "300px" }}>
                                <Input
                                    allowClear
                                    type='text'
                                    placeholder='Search'
                                    style={{ borderColor: "gray", width: "100%" }}
                                />
                            </div>
                        </div>
                        <div className='flex justify-end mr-2 align-middle italic' style={{ fontSize: "10px" }}>
                            Total : {chatlist.length || 0}
                        </div>

                        <Divider className='mt-0 mb-0 p-0' />

                        {/* Chatlist starts here */}
                        <div className='overflow-y-auto overflow-ellipsis mt-1 p-1' style={{ height: "100%" }}>


                            <div className="m-1.5 p-1 border rounded drop-shadow cursor-pointer hover:scale-105 active:scale-95 transition-transform duration-100 ease-in-out select-none" style={{ width: "300px", height: "50px", backgroundColor: "white" }}>
                                <div className="flex">
                                    <img style={{ width: "40px", height: "40px", borderRadius: "20px" }} src="https://media-ord5-3.cdn.whatsapp.net/v/t61.24694-24/437579811_1530779577809694_8958490356790829276_n.jpg?stp=dst-jpg_s96x96_tt6&ccb=11-4&oh=01_Q5AaIUfTFQVwFXkrbFA6n_fleSE9QYlb9_s4zykbtt6gWXUR&oe=67FB2998&_nc_sid=5e03e0&_nc_cat=107" alt="DP" loading="lazy" />
                                    <div className="pl-1" style={{ width: "130px" }}>
                                        <div className="text-nowrap overflow-ellipsis" title="Abhilash Used Spare Parts Trading LLC">Abhilash Used Spare Parts Trading LLC</div>
                                        <div className="italic" style={{ fontSize: "10px", color: "gray" }}>971509210105</div>
                                    </div>
                                </div>
                            </div>


                        </div>

                    </div>

                </div>
            </div >

            <ToastContainer />
        </>

    );
};

export default WhatsappMessages;
